import { CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { useState, useEffect } from 'react';
import FleetWebApi from "../Api/FleetWebApi";
import { Link } from "react-router-dom";

import IUser from "../models/Users/IUser";

import UserRole from "./UserRoleView";
import AddUser from "./AddUser";
import DeleteUser from "./DeleteUser";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditIcon from '@mui/icons-material/Edit';

export const AllUsers = () => {
    const [error, setError] = useState<string | null>(null);
    const [users, setUsers] = useState<IUser[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [limit] = useState(10);
    const [skip, setSkip] = useState(0);

    const nextPage = () => {
        setSkip(skip + limit);
    };

    const previousPage = () => {
        setSkip(skip - limit);
    };

    useEffect(() => {
        setIsLoading(true);
        FleetWebApi.getUsers(limit, skip)
            .then(response => {
                setUsers(response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    }, [skip, limit]);
    
    return (
        <Paper className="paper">
            <AddUser />
            {!isLoading && !error && (
            <Table classes={{ root: "reactivetable" }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>E-Mail</TableCell>
                        <TableCell>Roles</TableCell>
                        <TableCell>Edit</TableCell> 
                        <TableCell>Delete</TableCell> 

                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user, i) => (
                        <TableRow key={i}>
                            <TableCell>
                                {user.name}
                            </TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                                {user?.roles?.map((userRole, i) => (
                                    <UserRole key={i} role={userRole} />
                                ))}
                            </TableCell>
                            <TableCell>
                                <Link to={"user/" + user._id}>
                                    <Tooltip title="Edit User">
                                        <IconButton>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Link>
                            </TableCell> 
                            <TableCell>
                                <DeleteUser userId={user._id} />
                            </TableCell>
                        </TableRow>

                    ))}
                </TableBody>
            </Table>
            )}
            {isLoading && <CircularProgress color="secondary" />}
            {error}
            {skip !== 0 && (
                <IconButton onClick={previousPage}>
                    <ArrowBackIcon />
                </IconButton>
            )}
            {users.length !== 0 && limit === users.length && (
                <IconButton onClick={nextPage}>
                    <ArrowForwardIcon />
                </IconButton>
            )}
        </Paper>
    )
}